import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cssTransition,toast, ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import { APIHandler, BackImage, DataHandler,StorageHandler } from 'C4';
import { storageKeys, userKeys } from 'settings';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});


// {"rawData":"AEu4IL19nu1RZMf-wR_7-m0z1IAI3PErLHe_AuJALkpRcXusGbEaFrqmxsoY5BJkIA--DTVAozxeAW2OtFk37rM5EgywxtOcW25etEzIfpg4CvyK9fCHUxla1qcefxNjX8qsQJGjO1WBNRGyRjilfFGFbAypWdqzE95Qjc8V7EiuglJAL5-ruGvxtS1JCQgAIFpQco0bOHgiMJ31fIvkPtTwznu45vrYrvyMafEM1WZbLm_ZamPRw70","expires":1561817309376}
// existing account in both firebase and travpro: mattia@travpromobile.com
// AEu4IL10PWbBE8oRx9DEgy8zT536r6ND7HdRZIbqu8U2q2G0OSEJz9JJ8qUXZWE3SHhcwd4EP3eRkP7muF0BDzY3tUCH38cu0dWv9w7QQbDh0p4i7IMWqGUfzQKyvVjSYWlsGFzdmcKwfTh_nhi4Mic6DoP2sN9DsK259BFUnBR3W8WCJ_EXLEK80c_IdezCWCECV2PhXQ9zJRfu_tcJzI4F6eoGps4rVQ
export default class SSOView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: props.match.params.token,
      userEmail: '',
    };
  }

  componentWillMount() {
    const { token } = this.state;
    console.log(token);
    console.log('henk');
    if (typeof token === 'undefined') {
      toast.error('We couldn\'t find a valid token, please login again. If this problem persists, please contact us at: info@travpromobile.com.', {
        position: 'top-center',
        transition: Zoom,
        autoClose: 20000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      window.setTimeout(() => {
        window.location.href = '/login';
      }, 20000);
    } else {
      DataHandler.matchAppId().then((appId) => {
        APIHandler.refreshFirebaseToken(token).then((res) => {
          if (res.error) {
            StorageHandler.removeKeys(userKeys);
            // Toast error. Login Failed
            toast.error('We couldn\'t find your account in our database, please log in manually. You will be redirected in 10 seconds.', {
              position: 'top-center',
              transition: Zoom,
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            window.setTimeout(() => {
              window.location.href = '/login';
            }, 10000);
          } else {
            StorageHandler.save(storageKeys.refreshToken, res.refresh_token);
            StorageHandler.save(storageKeys.idToken, res.id_token, 180000);
  
            APIHandler.getFirebaseData(res.id_token).then((data) => {
              if (data && data.users && data.users[0]) {
                const { email } = data.users[0];
                APIHandler.getUserOld(appId, email).then((user) => {
                window.setTimeout(() => {
                  console.log(user.response);
                  if (user.response.length === 0) {
                    StorageHandler.save(storageKeys.email, email);
                    window.location.replace('/quick-register');
                  } else {
                    StorageHandler.save(storageKeys.user, user.response);
                    this.setState({ userEmail: user.email });
                    window.location.replace('/main');
                  }
                }, 1000);
                });
              }
            });
          }
        });
      });
    }
  }

  render() {
    return (
      <div className="SSOView">
        <BackImage darken />
          <div className="sso-content">
            <span className="spinner"><FontAwesomeIcon icon={['fas', 'circle-notch']} spin /></span>
            <p>{"Please wait, we are trying to sign you in right now."}</p>
            <ToastContainer
              draggablePercent={70}
            />
          </div>
      </div>
    );
  }
}

SSOView.propTypes = {
  token: PropTypes.string.isRequired,
};
